<!-- 多供应商采购>新增采购单 -->
<template>
    <div class="business-content-main trans-to-supplier-order" v-loading="searchApParams._visible" element-loading-spinner="none">
        <div>
            <div class="bread-nav">
                <breadcrumb :canBackHistory="true" :pageTitle="pageTitle"></breadcrumb>
            </div>
            <div class="section-title">
                <div>
                    商品明细
                </div>
                <div>
                    <el-button size="small" class="search-btn btn-primary" @click="showSearch()">搜索配件</el-button>
                    <el-button size="small" class="search-btn btn-primary" @click="submitForm()">创建采购订单</el-button>
                </div>
            </div>
        </div>

        <div id="infinite-list">
            <ux-grid
                ref="infiniteTable"
                :data="dataList"
                keep-source
                :height="infiniteTableHeight"
                :checkboxConfig="{ highlight: false }"
                :edit-config="{ trigger: 'click', mode: 'row' }"
                show-summary
                :summary-method="setSummaries"
                :row-style="setRowStyle"
                highlight-current-row
            >
                <ux-table-column class-name="table-sort" type="index" title="序号" width="65"></ux-table-column>
                <ux-table-column field="EntpCusItem" title="供应商" min-width="80" edit-render show-overflow-tooltip>
                    <template v-slot:header="{ column }"> <span class="color-red">*</span> {{ column.title }} </template>
                    <template v-slot="{ row, rowIndex }">
                        <div :class="['div-padding-12', { 'special-border': !row.EntpCusName }]" @click="focusHandle(rowIndex, 'custSelect')">{{ row.EntpCusName }}</div>
                    </template>
                    <template v-slot:edit="scope">
                        <el-select
                            ref="custSelect"
                            style="width: 100%"
                            :loading="loading"
                            size="small"
                            v-model="scope.row.EntpCusItem"
                            value-key="EntpCusId"
                            filterable
                            clearable
                            remote
                            reserve-keyword
                            placeholder="供应商"
                            @change="customerChange($event, scope.rowIndex)"
                            @visible-change="customerVisibleChange($event)"
                            :remote-method="
                                query => {
                                    searchCustomer(query, scope.row);
                                }
                            "
                            @keyup.enter.native="addItem(true)"
                            popper-class="el-select-style-gray"
                        >
                            <el-option v-for="optionItem in customerList" :key="optionItem.EntpCusId" :data-msg="optionItem" :label="optionItem.EntpCusName" :value="optionItem">
                            </el-option>
                        </el-select>
                    </template>
                </ux-table-column>
                <ux-table-column field="APCode" title="汽配编码" min-width="50" edit-render resizable show-overflow-tooltip>
                    <template v-slot:header="{ column }"> <span class="color-red">*</span> {{ column.title }} </template>
                    <template v-slot="{ row, rowIndex }">
                        <div :class="['sales-apcode div-padding-12', { 'special-border': !row.APCode }]" @click="focusHandle(rowIndex, 'code')">
                            <img class="info-icon" src="../../../assets/images/info.png" title="配件信息" @click.stop="showAPMsgDialog(row.EntpTempGoodsId)" />
                            <span>{{ row.APCode ? row.APCode : '请点击选中汽配编码' }}</span>
                        </div>
                    </template>
                    <template v-slot:edit="scope">
                        <el-select
                            :ref="'code' + scope.rowIndex"
                            :loading="loading"
                            :allow-create="isCheckCode"
                            default-first-option
                            size="small"
                            v-model="scope.row.APCode"
                            value-key="APCode"
                            filterable
                            clearable
                            remote
                            reserve-keyword
                            placeholder="汽配编码"
                            @change="codeChange($event, scope.rowIndex)"
                            @visible-change="apCodeVisibleChange($event)"
                            @keyup.enter.native="addItem(true)"
                            :remote-method="searchCode"
                            style="width: 100%"
                            popper-class="el-select-style-gray"
                        >
                            <el-option
                                v-for="optionItem in codeList"
                                :key="optionItem.EntpTempGoodsId"
                                :data-msg="optionItem"
                                :label="optionItem.APCode"
                                :value="isCheckCode? optionItem.APCode: optionItem.EntpTempGoodsId"
                            >
                                <div class="option-content">
                                    <div class="project-Name">{{ optionItem.APCode }}</div>
                                    <div class="project-Name">{{ optionItem.GoodName }}</div>
                                    <div class="project-Name in-one-line">
                                        {{ optionItem.AutoSerise }}
                                    </div>
                                    <div class="project-Name" v-if="changeCodeConfig">
                                        {{ optionItem.GoodCode }}
                                    </div>
                                </div>
                            </el-option>
                        </el-select>
                    </template>
                </ux-table-column>
                <ux-table-column field="GoodName" title="配件名称" min-width="50" edit-render show-overflow-tooltip>
                    <template v-slot:header="{ column }"> <span class="color-red">*</span> {{ column.title }} </template>
                    <template v-slot="{ row, rowIndex }">
                        <div :class="['div-padding-12', { 'special-border': !row.GoodName }]" @click="focusHandle(rowIndex, 'partsNameSelect')">{{ row.GoodName }}</div>
                    </template>
                    <template v-slot:edit="scope">
                        <el-input v-if="scope.row.IsNew" size="small" placeholder="配件名称" v-model="scope.row.GoodName" />
                        <el-select
                            v-else
                            ref="partsNameSelect"
                            style="width: 100%"
                            :loading="loading"
                            allow-create
                            size="small"
                            v-model="scope.row.GoodNameItem"
                            value-key="EntpTempGoodsId"
                            filterable
                            clearable
                            remote
                            reserve-keyword
                            placeholder="配件名称"
                            @change="nameChange($event, scope.rowIndex)"
                            @visible-change="apNameVisibleChange($event)"
                            :remote-method="
                                query => {
                                    searchName(query, scope.row);
                                }
                            "
                            @keyup.enter.native="addItem(true)"
                            popper-class="el-select-style-gray"
                        >
                            <el-option v-for="optionItem in nameList" :key="optionItem.EntpTempGoodsId" :data-msg="optionItem" :label="optionItem.GoodName" :value="optionItem">
                                <div class="option-content">
                                    <div class="project-Name">{{ optionItem.GoodName }}</div>
                                    <div class="project-Name">{{ optionItem.APCode }}</div>
                                    <div class="project-Name in-one-line">
                                        {{ optionItem.AutoSerise }}
                                    </div>
                                    <div class="project-Name" v-if="changeCodeConfig">
                                        {{ optionItem.GoodCode }}
                                    </div>
                                </div>
                            </el-option>
                        </el-select>
                    </template>
                </ux-table-column>
                <ux-table-column field="AutoSeriseItem" title="车型" min-width="50" edit-render show-overflow-tooltip>
                    <template v-slot:header="{ column }"> <span class="color-red">*</span> {{ column.title }} </template>
                    <template v-slot="{ row, rowIndex }">
                        <el-tooltip effect="dark" :content="row.AutoSerise" :disabled="!row.AutoSerise" placement="top">
                            <div :class="['div-padding-12', { 'special-border': !row.AutoSerise }]" @click="focusHandle(rowIndex, 'autoSeriseSelect')">{{ row.AutoSerise }}</div>
                        </el-tooltip>
                    </template>
                    <template v-slot:edit="scope">
                        <el-input size="small" v-model="scope.row.AutoSerise" placeholder="车系" v-if="scope.row.IsNew"> </el-input>
                        <el-select
                            v-else
                            ref="autoSeriseSelect"
                            :loading="loading"
                            allow-create
                            size="small"
                            v-model="scope.row.AutoSeriseItem"
                            value-key="EntpTempGoodsId"
                            :title="scope.row.AutoSerise"
                            filterable
                            clearable
                            remote
                            reserve-keyword
                            placeholder="车系"
                            @visible-change="autoSeriseVisibleChange($event, scope.row)"
                            :remote-method="
                                query => {
                                    searchAutoSerie(query, scope.row);
                                }
                            "
                            @change="seriseChange($event, scope.rowIndex)"
                            @keyup.enter.native="addItem(true)"
                            style="width: 100%"
                            popper-class="el-select-style-gray"
                        >
                            <el-option v-for="option in seriesList" :key="option.EntpTempGoodsId" :data-msg="option" :label="option.AutoSerise" :value="option">
                                <div class="option-content">
                                    <div class="project-Name" style="width: 300px">
                                        {{ option.AutoSerise }}
                                    </div>
                                    <div class="project-Name">{{ option.GoodName }}</div>
                                    <div class="project-Name">{{ option.APCode }}</div>
                                </div>
                            </el-option>
                        </el-select>
                    </template>
                </ux-table-column>
                <ux-table-column field="Origin" title="产地" v-if="isOriginShow" width="120" :edit-render="{ autofocus: '.el-input__inner' }" resizable key="origin">
                    <template v-slot="{ row }">
                        <div class="div-padding-12" @click="focusHandle(row.IsNew, row, 'originRef')">{{ row.Origin }}</div>
                    </template>
                    <template v-slot:edit="scope">
                        <el-input ref="originRef" size="small" v-model="scope.row.Origin"></el-input>
                    </template>
                </ux-table-column>
                <ux-table-column field="Size" v-if="isSizeShow" title="规格" width="80">
                    <template v-slot="scope">
                        <div class="div-padding-12">{{ scope.row.Size }}</div>
                    </template>
                </ux-table-column>
                <ux-table-column field="Count" title="数量" width="80" edit-render>
                    <template v-slot="{ row }">
                        <div :class="['div-padding-12', { 'special-border': ckeckIsOverLimit(row) }]">{{ row.Count }}</div>
                    </template>
                    <template v-slot:edit="scope">
                        <div class="sales-input-cell" v-if="isUpperLimit" :class="{ upperLimitWarning: ckeckIsOverLimit(scope.row) }">
                            <el-tooltip :disabled="!ckeckIsOverLimit(scope.row)" effect="light" placement="right">
                                <div slot="content">采购数超过预警上限：{{ scope.row.UpperLimit }}</div>
                                <el-input-number
                                    type="number"
                                    :ref="'count' + scope.rowIndex"
                                    :min="1"
                                    :precision="0"
                                    controls-position="right"
                                    size="small"
                                    v-model="scope.row.Count"
                                    @change="priceChange"
                                    @keyup.enter.native="addItem(true)"
                                ></el-input-number>
                            </el-tooltip>
                        </div>
                        <div class="sales-input-cell" v-else>
                            <el-input-number
                                type="number"
                                :ref="'count' + scope.rowIndex"
                                :min="1"
                                :precision="0"
                                controls-position="right"
                                size="small"
                                v-model="scope.row.Count"
                                @change="priceChange"
                                @keyup.enter.native="addItem(true)"
                            ></el-input-number>
                        </div>
                    </template>
                </ux-table-column>
                <ux-table-column field="Price" title="采购价" width="120" edit-render>
                    <template v-slot:header="{ column }">
                        <el-tooltip effect="dark" placement="bottom">
                            <div slot="content">
                                默认取向当前供应商的最新采购价格；<br />
                                若配件从未向当前供应商采购过，则取配件的成本价格
                            </div>
                            <span>
                                <i class="el-icon-warning-outline" style="color: orange; margin-right: 5px"></i>
                                <span class="color-red">*</span>
                            </span>
                        </el-tooltip>
                        {{ column.title }}
                    </template>
                    <template v-slot="{ row }">
                        <div :class="['div-padding-12', { 'special-border': !row.Price || row.Price === 0 }]">{{ row.Price }}</div>
                    </template>
                    <template v-slot:edit="scope">
                        <div class="sales-input-cell">
                            <el-input-number
                                size="small"
                                style="width: 100%"
                                :min="0"
                                :precision="2"
                                :step="0.01"
                                controls-position="right"
                                v-model="scope.row.Price"
                                @input="priceChange"
                                placeholder="采购价"
                                @keyup.enter.native="addItem(true)"
                            ></el-input-number>
                        </div>
                    </template>
                </ux-table-column>
                <ux-table-column field="cgzj" title="采购总价" width="90">
                    <template v-slot="{ row }">
                        <div class="div-padding-12">{{ row.Price * row.Count ? (row.Price * row.Count).toFixed(2) : 0 }}</div>
                    </template>
                </ux-table-column>
                <ux-table-column field="Inventory" title="库存数" width="80">
                    <template v-slot="scope">
                        <div class="div-padding-12">{{ scope.row.Inventory }}</div>
                    </template>
                </ux-table-column>
                <ux-table-column field="Relp" title="留余" width="50">
                    <template v-slot="scope">
                        <div class="div-padding-12">{{ scope.row.Inventory - scope.row.NeedOut + (isAddWaitIn ? scope.row.NeedIn : 0) }}</div>
                    </template>
                </ux-table-column>
                <ux-table-column field="NeedOut" title="待出" width="50">
                    <template v-slot="scope">
                        <div class="div-padding-12">{{ scope.row.NeedOut }}</div>
                    </template>
                </ux-table-column>
                <ux-table-column field="NeedIn" title="待入" width="50">
                    <template v-slot="scope">
                        <div class="div-padding-12">{{ scope.row.NeedIn }}</div>
                    </template>
                </ux-table-column>
                <ux-table-column title="操作" width="150">
                    <template v-slot="{ row, rowIndex }">
                        <div class="operate">
                            <i v-if="showIconDelete" class="el-icon-delete" title="移除" @click="delItem(rowIndex)"></i>
                            <i v-if="showIconAdd(rowIndex)" class="el-icon-plus" title="添加" @click="addItem(true)"></i>
                            <img v-if="row.EntpTempGoodsId" class="image-sup" src="@/assets/images/sup.png" title="采购历史" @click="showHistories(row)" />
                            <img v-if="row.EntpTempGoodsId" class="image-cus" src="@/assets/images/cus.png" title="销售历史" @click="showSaleStat(row)" />
                            <img
                                v-if="row.EntpTempGoodsId"
                                src="@/assets/images/analysis.png"
                                style="width: 22px; height: 22px; margin-left: 4px"
                                title="数据分析"
                                @click="analysis(row)"
                            />
                        </div>
                    </template>
                </ux-table-column>
            </ux-grid>
        </div>
        <!--   配件信息     -->
        <el-dialog :close-on-click-modal="false" title="配件信息" :visible.sync="APMsgVisible" width="1000px">
            <div v-if="APMsgVisible">
                <APMsg :dialogFormVisible="APMsgVisible" :EntpTempGoodsId="EntpTempGoodsIdEdit" @closeDialog="closeAPMsgDialog"></APMsg>
            </div>
        </el-dialog>
        <!--   搜索配件    -->
        <el-dialog :close-on-click-modal="false" title="搜索配件" :visible.sync="searchVisible" width="1200px">
            <div v-if="searchVisible">
                <searchAP @chooseAllAPsHandle="chooseAllAPsHandle" @closeDialog="closeSearchDialog" :SelectedData="selectedData"></searchAP>
            </div>
        </el-dialog>
        <!--    采购历史    -->
        <el-dialog :close-on-click-modal="false" title="采购历史" :visible.sync="historyVisible" width="1200px">
            <div v-if="historyVisible">
                <APPurchaseHistory
                    :EntpTempGoodsId="EntpTempGoodsIdEdit"
                    :EntpCusId="EntpCusId"
                    :EntpCusName="EntpCusName"
                    @closeDialog="
                        () => {
                            historyVisible = false;
                        }
                    "
                ></APPurchaseHistory>
            </div>
        </el-dialog>
        <!-- 销售历史 -->
        <el-dialog :title="SaleDialogTitle" :close-on-click-modal="false" :visible.sync="eyeHistoryVisible" append-to-body width="1200px">
            <div v-if="eyeHistoryVisible">
                <APHistory :showCusColumn="false" :EntpTempGoodsId="EntpTempGoodsIdEdit" @closeDialog="eyeHistoryVisible = false"></APHistory>
            </div>
        </el-dialog>
        <!-- 数据分析 -->
        <el-dialog :close-on-click-modal="false" title="商品销售采购数据图表" :visible.sync="goodsAnalysisVisible" width="1200px">
            <div class="dialog-content" v-if="goodsAnalysisVisible">
                <goodsAnalysis :GoodsId="EntpTempGoodsIdEdit" @closeDialog="goodsAnalysisVisible = false"></goodsAnalysis>
            </div>
        </el-dialog>
        <el-progress v-if="searchApParams._visible" class="saveProgress" type="circle" :percentage="searchApParams._percentage" />
    </div>
</template>
<script>
import breadcrumb from '@/components/common/breadcrumb';
import searchAP from '@/components/common/searchAP';
import APMsg from '@/components/common/APMsg';
import mixin from '@/mixins/mixin';
import APPurchaseHistory from '@/components/common/APPurchaseHistory';
import APHistory from '@/components/common/APHistory';
import goodsAnalysis from '@/components/common/goodsAnalysis';
export default {
    mixins: [mixin],
    name: '',
    components: {
        searchAP,
        APMsg,
        breadcrumb,
        APPurchaseHistory,
        APHistory,
        goodsAnalysis
    },
    data() {
        return {
            isCheckCode: true,
            needConfirm: true,
            dataStorageName: 'AddMultiSuPurOrders_dataList',
            historyVisible: false,
            EntpTempGoodsIdEdit: '',
            APMsgVisible: false,
            searchVisible: false,
            saving: false,
            allNum: 1,
            allMoney: 0,
            loading: false,
            Limit: 10,
            customerList: [],
            codeList: [],
            nameList: [],
            seriesList: [],
            dataList: [],
            pageTitle: '',
            eyeHistoryVisible: false,
            goodsAnalysisVisible: false,
            SaleDialogTitle: '',
            changeCodeConfig: false,
            infiniteListHeight: 0, // 列表高度，在收起信息栏时进行实时计算
            selectedData: [],
            priceCanBeZero: false,
            isUpperLimit: false,
            // 搜索配件弹框返回参数
            searchApParams: {
                _visible: false,
                _percentage: 0,
                _limit: 500,
                // 总数量
                _totalCount: 0
            },
            isAddWaitIn: true,
            EntpCusId: '',
            EntpCusName: '',
            isBPriceShow: false, //开单价
            isOriginShow:false,//产地
            isSizeShow:false,//规格            
        };
    },
    beforeRouteLeave(to, from, next) {
        this.$util.confirmBeforeLeave(to, from, next, this);
    },
    created() {},
    mounted() {
        let localStorage = null;
        this.getConfigByCodes();
        //判断缓存是否有数据，如果有取缓存数据
        localStorage = this.loadStorage();
        if (localStorage) {
            this.getDataFromChace(localStorage);
        }
        if (this.dataList.length == 0) {
            this.addItem(false);
        }

        //当表格出现滚动条后，编辑最后一条数据时，点击滚动条内底部的空白处单元格的编辑状态没有去除
        //为了解决这个bug在表格的父级监听点击事件来清除单元格激活状态
        let tablebody = document.querySelector('.elx-table--body-wrapper');
        tablebody.addEventListener('click', this.clearActived, false);

        window.onresize = () => {
            this.resetHeight();
        };
        setTimeout(() => {
            this.resetHeight();
        }, 0);
    },
    computed: {
        // 列表高度
        infiniteTableHeight() {
            let bottomHeight = 38;
            return this.infiniteListHeight - bottomHeight;
        },
        showIconDelete() {
            return this.dataList.length !== 1;
        },
        showIconAdd() {
            return function(rowIndex) {
                return rowIndex + 1 === this.dataList.length;
            };
        }
    },
    methods: {
        getConfigByCodes() {
            let codes = ['ddhhm', 'xsspjgwl', 'cgsxxz', 'lybsdr', 'xskdxskdj','kdspcd','kdspgg','xzqpbmdwyx'];
            this.$util.getSysConfigs(codes).then(data => {
                if (data) {
                    for (let i = 0; i < data.length; i++) {
                        let code = data[i].Code;
                        let result = data[i].Result;
                        switch (code) {
                            case 'ddhhm':
                                this.changeCodeConfig = result;
                                break;
                            case 'xsspjgwl':
                                this.priceCanBeZero = result;
                                break;
                            case 'cgsxxz':
                                this.isUpperLimit = result;
                                break;
                            case 'lybsdr':
                                this.isAddWaitIn = !result;
                                break;
                            case 'xskdxskdj': //本来用于开单价的，后面统一是开单价及产地等其他的展示
                                this.isBPriceShow = result;
                                break;
                            case 'kdspcd': //是否出现产地
                                this.isOriginShow = result;
                                break; 
                            case 'kdspgg': //是否出现规格
                                this.isSizeShow = result;
                                break;            
                            case 'xzqpbmdwyx': //是否检测编码重复
                                this.isCheckCode = result;
                                break; 
                        }
                    }
                }
            });
        },
        // 计算infinite-list高度
        resetHeight() {
            let listObj = document.getElementById('infinite-list');
            if (!listObj) return;
            let clientObj = listObj.getBoundingClientRect();
            this.infiniteListHeight = window.innerHeight - clientObj.top;
        },
        // 搜索
        showSearch() {
            this.searchVisible = true;
        },
        // 搜索配件弹框 - 确认筛选结果按钮操作
        chooseAllAPsHandle(data) {
            this.searchVisible = false;
            this.searchApParams = {
                ...data.searchData,
                limit: this.searchApParams._limit,
                _visible: true,
                _percentage: 0,
                _limit: this.searchApParams._limit,
                _totalCount: data.searchData.limit
            };
            this.loopSearch();
        },
        // 开始循环
        async loopSearch() {
            const { data } = await this.$util.axiosPost({
                url: '/api/EntpGoods/GetFullDataGoodsListForOrder',
                data: this.searchApParams,
                hideLoading: true
            });
            this.searchApParams._percentage = parseInt(((this.searchApParams.page * this.searchApParams.limit) / this.searchApParams._totalCount) * 100);
            this.searchApParams.page += 1;
            let _stop = !data || data.length < this.searchApParams._limit;
            this.closeSearchDialog(data);
            if (_stop) {
                this.searchApParams._percentage = 100;
                this.searchApParams._visible = false;
            } else {
                this.loopSearch();
            }
        },
        closeSearchDialog(items) {
            let that = this;
            let itemList = [...items];
            if (itemList.length == 0) {
                that.searchVisible = false;
                return;
            }
            let newGoodsList = [];
            for (let i = 0; i < itemList.length; i++) {
                let item = itemList[i];
                let newGoods = {};
                if (i == 0) {
                    newGoods = {
                        EntpCusId: '',
                        EntpCusName: '',
                        EntpCusItem: '',
                        EntpTempGoodsId: item.EntpTempGoodsId,
                        APCode: item.APCode,
                        GoodName: item.GoodName,
                        GoodNameItem: item.GoodName,
                        AutoSerise: item.AutoSerise,
                        AutoSeriseItem: item.AutoSerise,
                        Count: 1,
                        Inventory: item.Inventory,
                        NeedOut: item.OrderWaitOutQuantity,
                        NeedIn: item.POrderWaitInQuantity,
                        Price: item.LatestPurPrice ? item.LatestPurPrice : item.CostPrice,
                        CostPrice: item.CostPrice,
                        Unit: item.Unit,
                        State: 0,
                        Size: item.Size,
                        Origin: item.Origin,
                        UpperLimit: item.UpperLimit
                    };
                } else {
                    newGoods = {
                        EntpCusId: '',
                        EntpCusName: '同上',
                        EntpCusItem: '同上',
                        EntpTempGoodsId: item.EntpTempGoodsId,
                        APCode: item.APCode,
                        GoodName: item.GoodName,
                        GoodNameItem: item.GoodName,
                        AutoSerise: item.AutoSerise,
                        AutoSeriseItem: item.AutoSerise,
                        Count: 1,
                        Inventory: item.Inventory,
                        NeedOut: item.OrderWaitOutQuantity,
                        NeedIn: item.POrderWaitInQuantity,
                        Price: item.LatestPurPrice ? item.LatestPurPrice : item.CostPrice,
                        CostPrice: item.CostPrice,
                        Unit: item.Unit,
                        State: 0,
                        Size: item.Size,
                        Origin: item.Origin,
                        UpperLimit: item.UpperLimit
                    };
                }

                newGoodsList.push(newGoods);
            }
            //判断最后一条数据是否空值，是的话移到最后
            if (that.dataList.length == 0) {
                that.dataList = that.dataList.concat(newGoodsList);
            } else {
                let lastItem = that.dataList[that.dataList.length - 1];
                if (!lastItem.APCode && !lastItem.GoodName) {
                    that.dataList.splice(that.dataList.length - 1, 1);
                    that.dataList = that.dataList.concat(newGoodsList);
                    that.dataList.push(lastItem);
                } else {
                    that.dataList = that.dataList.concat(newGoodsList);
                }
            }

            that.priceChange();
            this.addPageChace();
            that.searchVisible = false;
            that.$nextTick(() => {
                if (that.$refs['count' + (that.dataList.length - 1).toString()]) {
                    that.$refs['count' + (that.dataList.length - 1).toString()][0].focus();
                }
            });
        },
        // 配件信息
        showAPMsgDialog(id) {
            if (id) {
                this.EntpTempGoodsIdEdit = id;
                this.APMsgVisible = true;
            }
        },
        closeAPMsgDialog(edit) {
            this.APMsgVisible = false;
            if (edit) {
                this.getOrderDetail();
            }
        },
        // 数量或者价格变动
        priceChange() {
            let DetailList = this.dataList;
            let _allNum = 0;
            let _allMoney = 0;
            for (let i = 0; i < DetailList.length; i++) {
                _allNum += Number(DetailList[i].Count);
                _allMoney += Number(DetailList[i].Count * DetailList[i].Price ? (DetailList[i].Count * DetailList[i].Price).toFixed(3) : 0);
            }
            this.allMoney = _allMoney;
            this.allNum = _allNum;
            this.dataList = DetailList;
        },

        // 提交采购单
        submitForm() {
            let that = this;
            if (that.saving) {
                return;
            }
            let _dataList = this.dataList;
            for (let i = 0; i < _dataList.length; i++) {
                if (!_dataList[i].EntpCusId && _dataList[i].EntpCusName != '同上') {
                    that.$util.warningMsg('请填写供应商');
                    return;
                }
                if (!_dataList[i].APCode) {
                    that.$util.warningMsg('请填写配件编码');
                    return;
                }
                if (!_dataList[i].GoodName) {
                    that.$util.warningMsg('请填写配件名称');
                    return;
                }
                if (!_dataList[i].Count || Number(_dataList[i].Count) < 0) {
                    that.$util.warningMsg('请填写正确的配件数量');
                    return;
                }
                if (!_dataList[i].AutoSerise) {
                    that.$util.warningMsg('请填写车型');
                    return;
                }
                if (!that.priceCanBeZero) {
                    if (!_dataList[i].Price || _dataList[i].Price < 0) {
                        that.$util.warningMsg('请填写正确的采购价');
                        return;
                    }
                }
                _dataList[i].SortNum = i + 1;
            }
            that.saving = true;
            let checkRepeat = this.checkRepeatAndReturnData(_dataList);
            if (checkRepeat.hasRepeat) {
                that.$confirm('订单含有重复商品项，是否需要累加', '', {
                    type: 'error',
                    distinguishCancelAndClose: true
                })
                    .then(() => {
                        // 覆盖数据
                        //检查是否超过库存上限
                        if (that.isUpperLimit) {
                            that.sumbit_ckeckIsOverLimit(checkRepeat.row);
                        } else that.submitData(checkRepeat.row);
                    })
                    .catch(() => {
                        that.saving = false;
                    });
            } else {
                if (that.isUpperLimit) {
                    that.sumbit_ckeckIsOverLimit(_dataList);
                } else {
                    that.submitData(_dataList);
                }
            }
        },
        submitData(data) {
            let that = this;
            let ids = [];
            let firstId = '';
            let firstName = '';
            for (let i = 0; i < data.length; i++) {
                let id = data[i].EntpCusId;
                if (id) {
                    firstId = id;
                    firstName = data[i].EntpCusName;
                    let index = ids.findIndex(f => f === id);
                    if (index == -1) ids.push(id);
                } else {
                    data[i].EntpCusId = firstId;
                    data[i].EntpCusName = firstName;
                }
            }
            if (ids.length == 0) {
                that.$util.warningMsg('未检测到供应商');
                return;
            }
            let url = '/api/EntpPurchaseOrder/VerifyMulSubmitPurOrder';
            that.$util
                .axiosPost({
                    url: url,
                    data: {
                        EntpCusIds: ids
                    },
                    hideLoading: true
                })
                .then(res => {
                    let result = res.data;
                    if (result && result.IsExist) {
                        that.$confirm(`已有相关供应商的未提交的采购单【${result.OrderCodes}】，是否合并这些采购单?`, '提示', {
                            confirmButtonText: '合并',
                            cancelButtonText: '新建',
                            type: 'warning',
                            center: true,
                            distinguishCancelAndClose: true,
                            closeOnClickModal: false
                        })
                            .then(() => {
                                that.saveMuilPurOrders(data, false);
                            })
                            .catch(action => {
                                if (action !== 'cancel') return;
                                that.saveMuilPurOrders(data, true);
                            });
                    }
                    else{
                        that.saveMuilPurOrders(data, true);
                    }
                })
                .catch(() => {
                    that.$util.warningMsg('验证出现异常，请联系技术人员');
                })
                .finally(() => {
                    that.saving = false;
                });
        },
        saveMuilPurOrders(data, isCreate) {
            let that = this;
            that.$util
                .axiosPost({
                    url: '/api/EntpPurchaseOrder/AddMultiSuPurOrders',
                    data: { IsCreate: isCreate, GoodsList: data }
                })
                .then(() => {
                    that.$store.commit('updateNeedRefresh', true);
                    that.needConfirm = false;
                    that.$util.successMsg('保存采购订单成功');
                    that.removePageChace();

                    setTimeout(() => {
                        this.$router.push('/purchaseManage/purchaseOrders');
                    }, 2000);
                })
                .catch(() => {
                    this.saving = false;
                });
        },
        // 检查是否有重复项及返回已合并数量的数据
        checkRepeatAndReturnData(data) {
            let [list, row, hasRepeat] = [data, [], false];
            if(this.isCheckCode){
                list.forEach(item => {
                    let index = row.findIndex(f => f.APCode === item.APCode && f.EntpCusId == item.EntpCusId);
                    if (index > -1) {
                        hasRepeat = true;
                        row[index].Count = Number(row[index].Count) + Number(item.Count);
                    } else {
                         row.push(Object.assign({}, item));
                    }
                });
            }
            else{
                list.forEach(item => {
                    let index = row.findIndex(f => f.EntpTempGoodsId === item.EntpTempGoodsId && f.EntpCusId == item.EntpCusId);
                    if (index > -1) {
                        hasRepeat = true;
                        row[index].Count = Number(row[index].Count) + Number(item.Count);
                    } else {
                        row.push(Object.assign({}, item));
                    }
                });
            }
            return {
                hasRepeat,
                row
            };
        },
        sumbit_ckeckIsOverLimit(data) {
            let that = this;
            let goodsList = [];
            data.forEach(item => {
                let i = goodsList.findIndex(f => f.APCode === item.APCode);
                if (i > -1) {
                    goodsList[i].Count += item.Count;
                } else {
                    goodsList.push(Object.assign({}, item));
                }
            });
            let index = goodsList.findIndex(f => Number(f.Count) + f.Inventory > f.UpperLimit);
            if (index > -1) {
                that.$confirm('订单含有商品采购总数已达预警上限，是否继续采购', '', {
                    type: 'error',
                    distinguishCancelAndClose: true
                })
                    .then(() => {
                        that.submitData(data);
                    })
                    .catch(() => {
                        that.saving = false;
                    });
            } else {
                that.submitData(data);
            }
        },
        // 删除某行
        delItem(index) {
            if (this.dataList.length != 1) {
                this.dataList.splice(index, 1);
            }
            this.priceChange();
            this.addPageChace();
        },
        // 添加一行
        addItem(addPageChace) {
            let that = this;
            let _dataList = that.dataList;
            for (let i = 0; i < _dataList.length; i++) {
                if (!_dataList[i].EntpCusId && _dataList[i].EntpCusName != '同上') {
                    that.$util.warningMsg('请填写供应商');
                    return;
                }
                if (!_dataList[i].APCode) {
                    that.$util.warningMsg('请填写配件编码');
                    return;
                }
                if (!_dataList[i].GoodName) {
                    that.$util.warningMsg('请填写配件名称');
                    return;
                }
                if (!_dataList[i].AutoSerise) {
                    that.$util.warningMsg('请填写车型');
                    return;
                }
                if (!that.priceCanBeZero) {
                    if (!_dataList[i].Price || _dataList[i].Price < 0) {
                        that.$util.warningMsg('请填写正确的采购价');
                        return;
                    }
                }
            }

            if (addPageChace) {
                that.addPageChace(); //添加销售订单缓存
            }

            let newGoods = {
                EntpCusId: '',
                EntpCusName: that.dataList.length == 0 ? '' : '同上',
                EntpCusItem: that.dataList.length == 0 ? '' : '同上',
                EntpTempGoodsId: '',
                APCode: '',
                GoodName: '',
                GoodNameItem: '',
                AutoSerise: '',
                AutoSeriseItem: '',
                Count: 1,
                Inventory: 0,
                NeedOut: 0,
                NeedIn: 0,
                Price: 0,
                CostPrice: '',
                Unit: '',
                State: 0,
                UpperLimit: 0,
                Origin: '',
                Size: ''
            };
            that.dataList.push(newGoods);
            that.priceChange();

            setTimeout(() => {
                that.$refs.infiniteTable.scrollToRow(that.dataList[that.dataList.length - 1]);
                that.$refs.infiniteTable.setActiveRow(that.dataList[that.dataList.length - 1]);
                if (that.dataList.length > 1) {
                    let ilEle = document.getElementsByClassName('business-content')[0];
                    ilEle.scrollTop = ilEle.scrollHeight;
                }
            }, 100);
        },
        // 点击展开下拉框
        focusHandle(index, type) {
            if (type === 'custSelect') {
                setTimeout(() => {
                    this.$refs[`custSelect`].focus();
                }, 200);
            }
            if (type === 'code') {
                setTimeout(() => {
                    this.$refs[`code${index}`].focus();
                }, 200);
            }
            if (type === 'partsNameSelect') {
                setTimeout(() => {
                    this.$refs[`partsNameSelect`].focus();
                }, 200);
            }
            if (type === 'autoSeriseSelect') {
                setTimeout(() => {
                    this.$refs[`autoSeriseSelect`].focus();
                }, 200);
            }
            if (type === 'unitSelect') {
                setTimeout(() => {
                    this.$refs[`unitSelect`].focus();
                }, 200);
            }
        },

        // 名称改变
        nameChange(item, index) {
            let that = this;
            if (!item) {
                that.dataList[index].VGoodName = '';
                that.dataList[index].GoodName = '';
            } else if (typeof item == 'string') {
                that.dataList[index].VGoodName = item;
                that.dataList[index].GoodName = item;
            } else {
                that.dataList[index].GoodName = item.GoodName;
                that.dataList[index].VGoodName = item.GoodName;
                that.dataList[index].Price = item.CostPrice;
                that.dataList[index].CostPrice = item.CostPrice;
                that.dataList[index].Unit = item.Unit;
                that.dataList[index].AutoSerise = item.AutoSerise;
                that.dataList[index].AutoSeriseItem = item.AutoSerise;
                that.dataList[index].State = 0;
                that.dataList[index].NeedIn = item.POrderWaitInQuantity;
                that.dataList[index].NeedOut = item.OrderWaitOutQuantity;
                that.dataList[index].Inventory = item.Inventory;
                that.dataList[index].Origin = item.Origin;
                that.dataList[index].Size = item.Size;
                that.dataList[index].UpperLimit = item.UpperLimit;
                if (!that.dataList[index].APCode) {
                    that.dataList[index].APCode = item.APCode;
                    that.dataList[index].EntpTempGoodsId = item.EntpTempGoodsId;

                    if (that.dataList[index].EntpCusId) {
                        that.getGoodsLatestPrice(that.dataList[index].EntpCusId, item.EntpTempGoodsId).then(resp => {
                            if (resp && Number(resp.Price) > 0) {
                                that.dataList[index].Price = Number(resp.Price);
                            } else {
                                that.dataList[index].Price = that.dataList[index].CostPrice;
                            }
                            that.priceChange();
                        });
                        return;
                    }
                }
                that.priceChange();
            }
        },
        // 编码改变
        codeChange(value, index) {
            let that = this;
            let isNew = true;
            let _list = this.codeList;
            if (!value) {
                this.dataList[index].IsNew = false;
                return;
            }
            let item = _list.find(v => this.isCheckCode ? (v.APCode == value):(v.EntpTempGoodsId == value));
            if (item) {
                that.dataList[index].APCode = item.APCode;
                that.dataList[index].EntpTempGoodsId = item.EntpTempGoodsId;
                that.dataList[index].GoodName = item.GoodName;
                that.dataList[index].GoodNameItem = item.GoodName;
                that.dataList[index].Price = item.CostPrice;
                that.dataList[index].CostPrice = item.CostPrice;
                that.dataList[index].Unit = item.Unit;
                that.dataList[index].AutoSerise = item.AutoSerise;
                that.dataList[index].AutoSeriseItem = item.AutoSerise;
                that.dataList[index].IsNew = false;
                that.dataList[index].State = 0;
                that.dataList[index].NeedIn = item.POrderWaitInQuantity;
                that.dataList[index].NeedOut = item.OrderWaitOutQuantity;
                that.dataList[index].Origin = item.Origin;
                that.dataList[index].Size = item.Size;
                that.dataList[index].Inventory = item.Inventory;
                that.dataList[index].UpperLimit = item.UpperLimit;
                isNew = false;
                if (that.dataList[index].EntpCusId) {
                    that.getGoodsLatestPrice(that.dataList[index].EntpCusId, item.EntpTempGoodsId).then(resp => {
                        if (resp && Number(resp.Price) > 0) {
                            that.dataList[index].Price = Number(resp.Price);
                        } else {
                            that.dataList[index].Price = that.dataList[index].CostPrice;
                        }
                        that.priceChange();
                    });
                    return;
                }
                that.priceChange();
                return;
            }
            if (isNew && value && this.isCheckCode) {
                that.$util.elConfirm({
                    content: '要创建一个新配件吗？',
                    noMsg: true,
                    confirm() {
                        that.dataList[index].EntpTempGoodsId = '';
                        that.dataList[index].Inventory = 0;
                        that.dataList[index].NeedOut = 0;
                        that.dataList[index].NeedIn = 0;
                        that.dataList[index].Price = 0;
                        that.dataList[index].CostPrice = 0;
                        that.dataList[index].IsNew = true;
                        that.dataList[index].State = 0;
                        that.dataList[index].UpperLimit = 0;
                        that.$refs.infiniteTable.setActiveRow(that.dataList[index]);
                        that.$util
                            .axiosGet({
                                url: '/api/EntpGoods/GetPart',
                                data: {
                                    APCode: value
                                },
                                hideLoading: true
                            })
                            .then(res => {
                                if (res.data) {
                                    let data = res.data;
                                    that.dataList[index].APCode = data.APCode;
                                    that.dataList[index].AutoSerise = data.AutoSerise;
                                    that.dataList[index].AutoSeriseItem = data.AutoSerise;
                                    that.dataList[index].GoodName = data.GoodName;
                                    that.dataList[index].GoodNameItem = data.GoodName;
                                    that.dataList[index].Unit = data.Unit;
                                }
                            });
                    }
                });
            }
            that.priceChange();
        },
        //车型改变  AutoSeriseItem值仅仅用于选中值为对象的效果，实际上保存的数据还是AutoSerise
        seriseChange(item, index) {
            let that = this;
            if (!item) {
                that.dataList[index].AutoSerise = '';
            } else if (typeof item == 'string') {
                that.dataList[index].AutoSerise = item;
            } else {
                that.dataList[index].APCode = item.APCode;
                that.dataList[index].GoodName = item.GoodName;
                that.dataList[index].VGoodName = item.GoodName;
                that.dataList[index].Price = item.CostPrice;
                that.dataList[index].CostPrice = item.CostPrice;
                that.dataList[index].Unit = item.Unit;
                that.dataList[index].AutoSerise = item.AutoSerise;
                that.dataList[index].State = 0;
                that.dataList[index].NeedIn = item.POrderWaitInQuantity;
                that.dataList[index].NeedOut = item.OrderWaitOutQuantity;
                that.dataList[index].Inventory = item.Inventory;
                that.dataList[index].Origin = item.Origin;
                that.dataList[index].Size = item.Size;
                that.dataList[index].UpperLimit = item.UpperLimit;

                if (that.dataList[index].EntpTempGoodsId != item.EntpTempGoodsId) {
                    that.getGoodsLatestPrice(item.EntpCusId, item.EntpTempGoodsId).then(resp => {
                        if (resp && Number(resp.Price) > 0) {
                            that.dataList[index].Price = Number(resp.Price);
                        } else {
                            that.dataList[index].Price = that.dataList[index].CostPrice;
                        }
                        that.priceChange();
                    });
                    that.dataList[index].EntpTempGoodsId = item.EntpTempGoodsId;
                } else {
                    that.priceChange();
                }
            }
        },
        // 供应商改变
        customerChange(item, index) {
            let that = this;
            if (!item) {
                that.dataList[index].EntpCusId = '';
                that.dataList[index].EntpCusName = '';
                that.dataList[index].Price = that.dataList[index].CostPrice;
            } else if (typeof item == 'string') {
                that.dataList[index].EntpCusName = item.EntpCusName;
            } else {
                that.dataList[index].EntpCusId = item.EntpCusId;
                that.dataList[index].EntpCusName = item.EntpCusName;
                if (that.dataList[index].EntpTempGoodsId) {
                    that.getGoodsLatestPrice(item.EntpCusId, that.dataList[index].EntpTempGoodsId).then(resp => {
                        if (resp && Number(resp.Price) > 0) {
                            that.dataList[index].Price = Number(resp.Price);
                        } else {
                            that.dataList[index].Price = that.dataList[index].CostPrice;
                        }
                    });
                }
            }
        },
        //当供应商下拉框出现时触发
        customerVisibleChange(event) {
            let that = this;
            if (event) {
                if (that.customerList.length <= 1) that.searchCustomer('');
            }
        },
        //当汽配件编码下拉框出现时触发
        apCodeVisibleChange(event) {
            let that = this;
            if (event) {
                if (that.codeList.length == 0) that.searchCode('');
            }
        },
        //当汽配件名称下拉框出现时触发
        apNameVisibleChange(event) {
            let that = this;
            if (event) {
                if (that.nameList.length == 0) that.searchName('');
            }
        },
        //当车系下拉框出现时触发
        autoSeriseVisibleChange(event, item) {
            let that = this;
            if (event) {
                if (that.seriesList.length == 0) that.searchAutoSerie('', item);
            }
        },
        // 历史销售
        showHistories(row) {
            if (row.EntpTempGoodsId) {
                this.EntpTempGoodsIdEdit = row.EntpTempGoodsId;
                this.EntpCusId = row.EntpCusId;
                this.EntpCusName = row.EntpCusName;
                this.historyVisible = true;
            }
        },
        showSaleStat(row) {
            if (row) {
                this.SaleDialogTitle = '销售数据：' + row.APCode + ' ' + row.GoodName + ' ' + row.AutoSerise;
                this.EntpTempGoodsIdEdit = row.EntpTempGoodsId;
                this.EntpCusId = row.EntpCusId;
                this.EntpCusName = row.EntpCusName;
                this.eyeHistoryVisible = true;
            }
        },
        analysis(row) {
            if (row) {
                this.EntpTempGoodsIdEdit = row.EntpTempGoodsId;
                this.goodsAnalysisVisible = true;
            }
        },
        // 设置展示合计数据行
        setSummaries() {
            return [['', '', '', '总数量', this.allNum, '', '合计', this.allMoney.toFixed(3), '', '']];
        },
        // 设置展示行样式
        setRowStyle(param) {
            const { row, index } = param;
            let rowArr = [];
            if(this.isCheckCode)
                rowArr = this.dataList.filter(f => f.APCode === row.APCode && f.EntpCusId === row.EntpCusId);
            else
                rowArr = this.dataList.filter(f => f.EntpTempGoodsId === row.EntpTempGoodsId && f.EntpCusId === row.EntpCusId);
            if (rowArr.length > 1) {
                return `background-color: #FFE8E8`;
            }
        },
        //判断是否有缓存,加载缓存或者请求订单信息
        loadStorage() {
            let datalist = this.$util.getLocalStorage(this.dataStorageName);
            if (datalist && datalist.length > 0) {
                return {
                    list: datalist
                };
            } else {
                return null;
            }
        },
        //添加页面缓存
        addPageChace() {
            this.removePageChace();
            this.$util.setLocalStorage(this.dataStorageName, this.dataList);
        },
        //清除页面缓存
        removePageChace() {
            this.$util.clearLocalStorage(this.dataStorageName);
        },
        //从缓存中读取数据
        getDataFromChace(data) {
            let datalist = data.list;
            if (datalist && datalist.length > 0) {
                let _allNum = 0;
                let _allMoney = 0;
                for (let i = 0; i < datalist.length; i++) {
                    _allNum += Number(datalist[i].Count);
                    _allMoney += datalist[i].Count * datalist[i].Price ? datalist[i].Count * datalist[i].Price : 0;
                }
                this.allMoney = _allMoney;
                this.allNum = _allNum;
                this.dataList = datalist;
            }
        },

        // 搜索顾客
        searchCustomer(key) {
            this.loading = true;
            this.customerList = [];
            this.$util.searchSupplier(key).then(data => {
                this.loading = false;
                this.customerList = this.$util.uniqueArr(this.customerList, data);
            });
        },
        // 搜索汽配编码
        searchCode(key) {
            this.loading = true;
            return new Promise(resolve => {
                this.$util
                    .axiosGet({
                        url: '/api/EntpGoods/GetGoodsSelItemsForPurchaseOrder',
                        data: {
                            APCode: key,
                            Limit: this.Limit
                        },
                        hideLoading: true
                    })
                    .then(res => {
                        this.loading = false;
                        this.codeList = res.data?res.data:[];
                        resolve();
                    });
            });
        },
        // 搜索名称
        searchName(key, item) {
            this.loading = true;
            this.$util
                .axiosGet({
                    url: '/api/EntpGoods/GetGoodsSelItemsForPurchaseOrder',
                    data: {
                        GoodName: key,
                        Limit: this.Limit
                    },
                    hideLoading: true
                })
                .then(res => {
                    this.loading = false;
                    this.nameList =  res.data?res.data:[];
                    if (item) {
                        item.VGoodName = key;
                        item.GoodName = key;
                        this.seriesList = res.data;
                    }
                });
        },
        // 搜车系
        searchAutoSerie(key, item) {
            this.loading = true;
            this.$util
                .axiosGet({
                    url: '/api/EntpGoods/GetGoodsSelItemsForPurchaseOrder',
                    data: {
                        GoodName: item ? item.VGoodName : '', //配合商品名称查
                        Limit: this.Limit,
                        OnlySeries: true,
                        SeriesName: key
                    },
                    hideLoading: true
                })
                .then(res => {
                    this.loading = false;
                    this.seriesList =  res.data?res.data:[];
                });
        },
        //检查是否超出上限
        ckeckIsOverLimit(goods) {
            if (!this.isUpperLimit) return false;
            //相同编码的商品都要计算
            let count = 0;
            this.dataList.forEach(item => {
                if (item.APCode == goods.APCode) count += item.Count;
            });
            return count + goods.Inventory > goods.UpperLimit;
        },
        getGoodsLatestPrice(sId, id) {
            return new Promise(resolve => {
                this.$util
                    .axiosGet({
                        url: '/api/EntpPurchaseOrder/GetGoodsLatestPriceBySId',
                        data: {
                            sId: sId,
                            id: id
                        }
                    })
                    .then(res => {
                        resolve(res.data);
                    });
            });
        },
        //手动清除单元格激活状态
        clearActived(e) {
            if (e.target.className == 'elx-table--body-wrapper body--wrapper') {
                this.$refs.infiniteTable.clearActived();
            }
            e.stopPropagation();
            e.preventDefault();
        }
    }
};
</script>
<style lang="less" scoped>
.payment-tip {
    position: absolute;
    left: 0;
    bottom: -18px;
    line-height: 1;
    font-size: 12px;
    color: @font4Color;
}
.search-ctn {
    border: 1px solid @border3Color;
    padding-top: 20px;
    margin-bottom: 20px;
}
.form-main {
    display: flex;
    flex-direction: row;
    width: 100%;
    height: auto;
}
.form-bottom {
    width: 100%;
    display: flex;
    flex-direction: row;
    div {
        width: 50%;
    }
}
.form-applyzone {
    display: flex;
    flex-direction: row;
    width: 100%;
    height: auto;
}
.form-account {
    width: 57.7%;
    float: left;
    margin-left: 30px;
    border: 1px dashed #888888;
    border-radius: 10px;
}
.inventory-title {
    line-height: 1.2;
    flex-direction: column;
    > div:nth-child(1) {
        width: 100%;
        border-bottom: 1px solid @border3Color;
    }
    > div:nth-child(2) {
        width: 100%;
        display: flex;
        > div {
            width: 33.33%;
        }
    }
}
.form-section {
    display: flex;
}
.section-title {
    display: flex;
    justify-content: space-between;
    height: 36px;
    line-height: 36px;
    padding: 0 20px;
    font-weight: bold;
    font-size: @font-sm;
    margin-left: -1px;
    background: @border3Color;
}
.edit-ctn {
    .div-table-cell {
        padding: 0 5px;
    }
}
.option-content {
    display: flex;
    line-height: 30px;

    .project-Name {
        width: 200px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        margin-right: 12px;
    }
}
.btn-ctn {
    margin-right: 110px;
    padding: 30px 0;
    text-align: right;
    padding-bottom: 180px;
}
.add-btn {
    position: absolute;
    right: 2%;
    bottom: 0;
}
.less-btn {
    position: absolute;
    right: -40px;
    top: 2px;
    z-index: 2;
}
.table-main {
    position: relative;
}
.image-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 60px;
    height: 60px;
    border: 1px dashed @border3Color;
}
.table-title {
    line-height: 36px;
    text-align: center;
    font-weight: bold;
}
.div-table-cell {
    display: flex;
    align-items: center;
    justify-content: center;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
}
.table-item {
    height: 50px;
    position: relative;
}
.div-table-row {
    overflow: inherit;
    margin: -1px -1px -1px 0px;
}
.div-table-cell-code {
    position: relative;
    .row-delete {
        position: absolute;
        padding: 1px 6px;
        top: 0;
        right: 0;
        color: #fff;
        background: #ffcc66;
        border-radius: 12.5px;
    }
}
.addresscls {
    display: flex;
    flex-direction: row;
}
.addicon {
    height: 30px;
    margin-left: 10px;
    margin-top: 5px;
}
.operate {
    height: 30px;
    // > i {
    //   margin-top: 8.5px;
    //   margin-right: 10px;
    //   cursor: pointer;
    // }
    display: flex;
    align-items: center;
    .el-icon-delete {
        margin-right: 8px;
        cursor: pointer;
    }
    .el-icon-plus {
        margin-right: 8px;
        cursor: pointer;
    }
    .image-sup {
        width: 27px;
        height: 27px;
        margin-right: 2px;
    }
    .image-cus {
        width: 26px;
        height: 26px;
    }
}
.saveProgress {
    position: absolute;
    top: 38%;
    left: 45%;
    z-index: 99999;
}
</style>
<style lang="less">
.el-row {
    margin-bottom: 20px;
    &:last-child {
        margin-bottom: 20px;
    }
}
.el-col {
    border-radius: 4px;
}
.bg-purple-dark {
    background: #99a9bf;
}
.bg-purple {
    background: #d3dce6;
}
.bg-purple-light {
    background: #e5e9f2;
}
.grid-content {
    border-radius: 4px;
    min-height: 36px;
}
.row-bg {
    padding: 10px 0;
    background-color: #f9fafc;
}
.check-code-class {
    .el-input__inner {
        border: 1px solid #f56c6c;
    }
}
.trans-to-supplier-order {
    .elx-table {
        .elx-body--row.row--hover,
        .elx-body--row.row--hover.row--stripe {
            background-color: #dcdee1;
        }
        .elx-table--body-wrapper {
            .elx-body--row {
                .table-sort {
                    .elx-cell {
                        padding: 4px 12px 0;
                    }
                }
                .div-padding-12 {
                    padding: 4px 12px 0;
                }
                .operate {
                    padding: 0 12px;
                }
                .text-btn {
                    button {
                        padding-left: 0;
                        padding-right: 0;
                    }
                }
                td {
                    height: 26px;
                }
            }
            .elx-cell {
                padding: 0;
                height: 32px;
            }
            .el-button--small {
                padding: 5px 15px;
                margin: 3px 9px 0 0;
            }
        }
        .elx-table--footer-wrapper {
            margin-top: 0 !important;

            .elx-footer--row {
                .elx-footer--column {
                    height: 34px;
                }

                .elx-cell {
                    padding: 4px 12px 0;
                }
            }
        }
        .elx-table--body-wrapper {
            padding-bottom: 180px !important;
        }
    }
    .sales-input-cell {
        .el-input-number {
            width: 100%;
        }
        .el-input {
            .el-input__inner {
                padding-left: 0;
                padding-right: 20px;
            }
        }
        .el-input-number__decrease,
        .el-input-number__increase {
            width: 20px;
        }
    }
    .special-border {
        height: 100%;
        border-radius: 3px;
        border: 1px solid #ffcc00;
    }
    .sales-apcode {
        .el-tag {
            height: 24px;
            line-height: 22px;
            margin-left: 8px;
        }
        .info-icon {
            vertical-align: top;
            margin-top: 2px;
            margin-right: 5px;
        }
    }
    .upperLimitWarning {
        .el-input__inner {
            border: 1px solid #e6a23c;
        }
    }
}
</style>
